<template>
  <b-modal
      v-bind="$props"
      :id="id"
      centered
      footer-class="submitted-at-modal-footer"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
  >
    <validation-observer ref="form" tag="div">
      <div class="text-center">
        <img :src="SuccessIcon" alt="" class="d-block mx-auto mb-3" height="48" width="48">
        <h4 class="submitted-at-title">{{ $t('purchase_plans.modal_messages.confirm_submitted_at_title') }}</h4>
        <p class="submitted-at-description m-0" v-html="confirmDescription"></p>
      </div>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('purchase_plans.modal_messages.submitted_at_reason_label'))"
          rules="required"
          vid="reason"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :state="errors[0] ? false : (validated ? true : null)"
            class="submitted-at-reason text-start"
            label-for="purchase-plan-submitted-at-reason"
        >
          <template #label>
            {{ lodash.startCase($t('purchase_plans.modal_messages.submitted_at_reason_label')) }}<span class="required-mark">*</span>
          </template>
          <b-form-textarea
              id="purchase-plan-submitted-at-reason"
              v-model="form.reason"
              :placeholder="$t('purchase_plans.modal_messages.submitted_at_reason_placeholder')"
              :state="errors[0] ? false : (validated ? true : null)"
              rows="3"
          />
        </b-form-group>
      </validation-provider>
    </validation-observer>
    <template #modal-footer>
      <div class="d-flex gap-3 w-100">
        <b-button
            class="w-50 submitted-at-button"
            variant="light"
            @click="handleCancel"
        >
          {{ $t('Back') }}
        </b-button>
        <b-button
            class="w-50 m-0 submitted-at-button"
            variant="primary"
            @click="handleConfirm"
        >
          {{ lodash.startCase($t('purchase_plans.buttons.save')) }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ConfirmationModal from '@/components/modals/confirmation-modal.vue'
import SuccessIcon from '@/assets/icons/SuccessIcon.svg'

export default {
  name: 'purchase-plan-submitted-at-confirmation',
  extends: ConfirmationModal,
  props: {
    id: {default: 'purchase-plan-submitted-at-confirmation-modal'},
    hideHeader: {default: true},
    title: {default: ''},
  },
  data() {
    return {
      SuccessIcon,
      options: {
        submittedAt: '',
      },
      form: {
        reason: '',
      },
      resolvePromise: null,
    };
  },
  computed: {
    confirmDescription() {
      return this.$t('purchase_plans.modal_messages.confirm_submitted_at_description', {
        date: `<strong>${this.lodash.escape(this.options.submittedAt)}</strong>`,
      })
    },
  },
  methods: {
    show(options = {}) {
      return new Promise((resolve) => {
        this.options = {
          submittedAt: '',
          ...options,
        }
        this.form.reason = ''
        this.resolvePromise = resolve
        this.$bvModal.show(this.id)

        this.$nextTick(() => {
          this.$refs.form?.reset()
        })
      })
    },
    async handleConfirm() {
      if (!this.$refs.form) {
        return
      }

      const isValid = await this.$refs.form.validate()
      if (!isValid) {
        return
      }

      if (this.resolvePromise) {
        this.resolvePromise({
          reason: this.form.reason.trim(),
        })
      }
      this.hide()
    },
    handleCancel() {
      if (this.resolvePromise) {
        this.resolvePromise(false)
      }
      this.hide()
    },
    hide() {
      this.$bvModal.hide(this.id)
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-body {
    padding: 24px 20px 0;
  }

  .submitted-at-modal-footer {
    border: none;
    padding: 40px 6px 6px;
  }
}

.submitted-at-title {
  margin-bottom: 12px;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  color: #101828;
}

.submitted-at-description {
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  color: #667085;

  ::v-deep strong {
    font-weight: 700;
  }
}

.submitted-at-reason {
  margin-top: 24px;
  margin-bottom: 0;

  ::v-deep label {
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 700;
    color: #101828;
  }

  ::v-deep textarea.form-control {
    padding: 12px;
    border-radius: 8px;
    border-color: #D0D5DD;
    font-size: 16px;
    line-height: 24px;

    &::placeholder {
      color: #667085;
    }
  }
}

.required-mark {
  color: #DC2626;
}

.submitted-at-button {
  height: 40px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;

  &.btn-light {
    background-color: #F2F4F7;
    color: #101828;
  }
}
</style>
